import { render, staticRenderFns } from "./check-identity.vue?vue&type=template&id=5732a170&scoped=true&"
import script from "./check-identity.vue?vue&type=script&lang=js&"
export * from "./check-identity.vue?vue&type=script&lang=js&"
import style0 from "./check-identity.vue?vue&type=style&index=0&id=5732a170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732a170",
  null
  
)

export default component.exports